import { render, staticRenderFns } from "./Mastercard.vue?vue&type=template&id=b2e1c474"
import script from "./Mastercard.vue?vue&type=script&lang=js"
export * from "./Mastercard.vue?vue&type=script&lang=js"
import style0 from "./Mastercard.vue?vue&type=style&index=0&id=b2e1c474&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports